<template>
  <md-toolbar
    md-elevation="0"
    class="md-transparent"
    :class="{
      'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute, 'hide': toolbarIndex === -1
    }"
    :style="{ 'z-index': toolbarIndex }"
  >
    <div class="md-toolbar-row">
      <div>
        <BotPageTitle :fontSize="'25'" />
      </div>
      <md-button
              class="md-just-icon md-round md-simple md-toolbar-toggle"
              :class="{ toggled: $sidebar.showSidebar, 'hide': !$vuetify.breakpoint.smAndDown && !showDateInterval }"
              @click="toggleSidebar"
            >
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
      </md-button>
    </div>
    <div class="md-toolbar-section-end">
        <DateInterval
          :dateObjInterval='dateInterval'
          @update='updateDateOnStore($event)'
          v-if='showDateInterval'
          :max30='$route.path === "/historico-produtividade"'
          :visibleSelect='whichTenant()'
          :dashboard="isDashboardSelect()"
          :isShowMenu="this.$route.path === '/eficiencia' && this.$route.path === '/analise-por-servico-entregue'"
        />
    </div>
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-end">
            <MenuSubMenu
            @update='updateDataSubMenu($event)'
            v-if='showDateInterval && isShowMenu'
        />
      </div>
    </div>
  </md-toolbar>
</template>

<script>
import BotPageTitle from '@/components/BotPageTitle.vue'
import DateInterval from '@/components/DateInterval.vue'
import MenuSubMenu from '@/components/menuSubMenu.vue'
import isTenantMixin from '@/components/mixins/isTenantMixin'
import { mapFields } from 'vuex-map-fields'

export default {
  components: {
    BotPageTitle,
    DateInterval,
    MenuSubMenu
  },
  mixins: [isTenantMixin],
  computed: {
    ...mapFields('reports', ['dateInterval']),
    toolbarIndex () {
      const routes = [
        '/visao-geral',
        '/eficiencia',
        '/historico-conversas',
        '/historico-produtividade',
        '/busca-por-mensagens',
        '/auditoria-atendimento',
        '/mensagens-nao-entendidas',
        '/curadoria',
        '/analise-por-servico-entregue',
        '/log-acesso',
        '/campanha-desempenho-geral',
        '/lista-campanhas',
        '/configuracoes-funcionalidades',
        '/consulta-usuario-teams',
        '/contatos-ativos'
      ]
      if (this.$vuetify.breakpoint.smAndDown) {
        return '5'
      } else if (
        this.$vuetify.breakpoint.mdAndUp && routes.includes(this.$route.path)
      ) {
        return '5'
      } else {
        return '-1'
      }
    },
    showDateInterval () {
      return this.$route.path === '/visao-geral' || this.$route.path === '/eficiencia' || this.$route.path ===
          '/historico-conversas' || this.$route.path === '/busca-por-mensagens' || this.$route.path ===
          '/auditoria-atendimento' || this.$route.path === '/mensagens-nao-entendidas' || this.$route.path ===
          '/curadoria' || this.$route.path === '/analise-por-servico-entregue' || this.$route.path ===
          '/log-acesso' || this.$route.path === '/campanha-desempenho-geral' || this.$route.path ===
          '/lista-campanhas' || this.$route.path ===
          '/configuracoes-funcionalidades'
    },
    isShowMenu () {
      const routes = [
        '/eficiencia',
        '/mensagens-nao-entendidas',
        '/analise-por-servico-entregue'
      ]
      return routes.includes(this.$route.path)
    }
  },
  data () {
    return {
      menu: { key: 'Todos', value: 'all' },
      subMenu: { key: 'Todos', value: 'all' },
      visibleSelect: false
    }
  },
  methods: {
    isDashboardSelect () {
      if (this.isRegularize || this.isYaraLtm || this.isDemo) {
        return true
      }
    },
    whichTenant () {
      if (this.isRegularize) {
        this.visibleSelect = this.isRegularize
      }
      if (this.isYaraLtm) {
        this.visibleSelect = this.isYaraLtm
      }
      if (this.isDemo) {
        this.visibleSelect = this.isDemo
      }
      return this.visibleSelect
    },
    toggleSidebar () {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
    },
    minimizeSidebar () {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize()
      }
    },
    updateDataSubMenu (dInt) {
      this.menu = dInt.menu.key
      this.submenu = dInt.submenu.name
    },
    updateDateOnStore (dInt) {
      this.$store.dispatch('reports/updateDateInterval', {
        timestamp1: dInt.timestamp1,
        timestamp2: dInt.timestamp2,
        select: dInt.select,
        menu: this.menu,
        submenu: this.submenu
      })
    }
  }
}
</script>

<style scoped>
  .md-toolbar-row {
    display: flex;
    justify-content: space-between;
  }
  .hide {
    display: none;
  }
</style>
